import { styled } from 'styled-components'
import { Box, Flex, Text, useToast } from '@pancakeswap/uikit'
import { useAppDispatch } from 'state'
import { useAllSortedRecentTransactions, useCustomToast } from 'state/transactions/hooks'
import { useTranslation } from '@pancakeswap/localization'
import { clearAllTransactions } from 'state/transactions/actions'
import isEmpty from 'lodash/isEmpty'
import EButton from 'components/EButton'
import TransactionRow from './TransactionRow'
import { chains } from '../../../utils/wagmi'

const TransactionsContainer = styled(Box)`
  max-height: 300px;
  overflow-y: auto;
`

interface WalletTransactionsProps {
  onDismiss: () => void
}

const WalletTransactions: React.FC<React.PropsWithChildren<WalletTransactionsProps>> = ({ onDismiss }) => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const sortedTransactions = useAllSortedRecentTransactions()

  const { toastTransaction } = useCustomToast()

  const hasTransactions = !isEmpty(sortedTransactions)

  const handleClearAll = () => {
    dispatch(clearAllTransactions())
  }

  return (
    <Box>
      {/* {hasTransactions && (
        <Text style={{ cursor: 'pointer' }} onClick={handleClearAll} color="secondary" fontSize="12px" textTransform="uppercase" fontWeight="bold">
          {t('Clear All')}
        </Text>
      )} */}
      {hasTransactions ? (
        <TransactionsContainer>
          {Object.entries(sortedTransactions).map(([chainId, transactions]) => {
            const chainIdNumber = Number(chainId)
            return (
              <Box key={chainId}>
                {/* <Text fontSize="14px" color="textSubtle" mb="4px">
                  {chains.find((c) => c.id === chainIdNumber)?.name ?? 'Unknown network'}
                </Text> */}
                {Object.values(transactions).map((txn) => (
                  <Box key={txn.hash} mb="4px" onClick={() => toastTransaction(txn)}>
                    <TransactionRow
                      txn={txn}
                      chainId={chainIdNumber}
                    />
                  </Box>
                ))}
              </Box>
            )
          })}
        </TransactionsContainer>
      ) : (
        <Text textAlign="center">{t('No recent transactions')}</Text>
      )}
    </Box>
  )
}

export default WalletTransactions
